import axios from "axios";
import { API_URL } from "../utils/constant";
import { OVERVIEW_LIST } from ".";
import { toastr } from "react-redux-toastr";

export const getOverviewList = (orgId, dispatch, page, actionType, status) => {
  if (orgId) {
    axios
      .get(
        `${API_URL}/ticket-system/${orgId}/overview?page=${page}&limit=10&actionType=${actionType}&status=${status}`
      )
      .then((res) => {
        dispatch({
          type: OVERVIEW_LIST,
          data: res.data,
        });
      });
  }
};

export const updateTicket = (
  recordId,
  data,
  id,
  dispatch,
  actionType = "",
  status = ""
) => {
  if (recordId) {
    axios
      .patch(`${API_URL}/ticket-system/${recordId}/updateticket`, data)
      .then((res) => {
        if (res.data.success) {
          getOverviewList(id, dispatch, 1, actionType, status);
          toastr.success("Success", res.data.message);
        } else {
          toastr.error("Error", res.data.message);
        }
      });
  }
};

export const removeTicket = (
  recordId,
  id,
  dispatch,
  actionType = "",
  status = ""
) => {
  if (recordId) {
    axios.delete(`${API_URL}/ticket-system/${recordId}/delete`).then((res) => {
      if (res.status === 200) {
        getOverviewList(id, dispatch, 1, actionType, status);
        toastr.success("Success", res.data.userMessage);
      } else {
        toastr.error("Error", res.data.userMessage);
      }
    });
  }
};
